import noodleApiClient, { ApiDefinition } from '@noodleApi';

type THIS_API = ApiDefinition['/workflows/user-workflows/{userWorkflowId}/comments/{messageId}']['GET'];

type Input = THIS_API['params'];
type Output = THIS_API['response'];

const getWorkflowConversationMessageById = async ({ userWorkflowId, messageId }: Input): Promise<Output> => {
  const response = await noodleApiClient.get(`/workflows/user-workflows/${userWorkflowId}/comments/${messageId}`);
  return response.data;
};

export default getWorkflowConversationMessageById;
